export default __webpack_public_path__ + "static/media/Next.bd015c81.svg";